import React from 'react';

import classes from '../installPics.css';

import Photo from '../../../../../../../assets/SE_Inverter&Optimizer.jpg';

const Image = () => (
    <div className={classes.installImages}>
        <img alt="Solar Edge inverter and Optimizer" src={Photo} className={classes.installImg} />
    </div>
);


export default Image;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/InstallImages/Inverters/SolarEdge.js